// 用于大数据表格
import Vue from 'vue'
import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css' // 引入样式

Vue.use(UmyUi)
